//https://michalsnik.github.io/aos/ https://github.com/michalsnik/aos
import AOS from 'aos';
import 'aos/dist/aos.css';
import {cl} from "./common";

document.addEventListener("DOMContentLoaded", function (){
	cl('AOS - Animate Scroll Library init');
	AOS.init();
})

document.addEventListener('aos:in', ({ detail }) => {
	console.log('animated in', detail);
});

document.addEventListener('aos:out', ({ detail }) => {
	console.log('animated out', detail);
});
